import { createNamedAction } from 'helpers/ActionUtil'

import {
  RUN_RISK_VALIDATION,
  OVERVIEW_UPDATE_STATE,
  OVERVIEW_ADD_MEMORY,
  OVERVIEW_REFRESH_MEMORY,
  UPDATE_STATE_ENTIRE_OBJ,
  UPDATE_CLOCK_VALUE,
  OPEN_MEMORY_BROWSER_WITH_FILTER,
  TOGGLE_POPUP,
  TOGGLE_FILTER,
  PART_TYPE,
  DENSITY,
  ORG_SIZE,
  ORG_WIDTH,
  CHANNEL,
  INITIALIZE_FILTER,
  INITIALIZE_CONFIG,
  UPDATE_CONFIG_SELECTION,
  UPDATE_CONFIG_SOURCE,
  ADD_CONFIG,
  INIT_CLOCK_VALUE,
  DELETE_PART,
  UPDATE_CURRENT_CONFIG,
  REFRESH_FILTER,
  CONFIG,
  INIT_CONFIG,
  IS_ADD_PART,
  INITIALIZE_CONFIG_FILTER
} from './constants'

export const runRiskValidation = () => ({ type: RUN_RISK_VALIDATION })

export const overviewUpdateState = (state, newValue) => {
  return {
    type: OVERVIEW_UPDATE_STATE,
    state,
    newValue
  }
}

export const addMemory = () => {
  return {
    type: OVERVIEW_ADD_MEMORY
  }
}

export const refreshMemory = () => {
  return {
    type: OVERVIEW_REFRESH_MEMORY
  }
}

export const updateStateEntireObj = (stateList, valueObj) => {
  return {
    type: UPDATE_STATE_ENTIRE_OBJ,
    stateList,
    valueObj
  }
}

export const updateClockValues = (config, value) => {
  return {
    type: UPDATE_CLOCK_VALUE,
    value,
    config
  }
}

export const openMemoryBrowserWithFilter = (categoryKey) => {
  return {
    type: OPEN_MEMORY_BROWSER_WITH_FILTER,
    categoryKey
  }
}

export const initConfig = () => {
  return {
    type: INIT_CONFIG,
  }
}

export const addConfig = (configs) => {
  return {
    type: ADD_CONFIG,
    configs
  }
}

export const deletePart = (deleteId) => {
  return {
    type: DELETE_PART,
    deleteId
  }
}

/*
  UI State Related
*/

export const togglePopup = () => {
  return {
    type: TOGGLE_POPUP,
  }
}

export const updateConfigSelection = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SELECTION,
    newConfig
  }
}

export const updateConfigSource = (newConfig) => {
  return {
    type: UPDATE_CONFIG_SOURCE,
    newConfig
  }
}

export const updateCurConfig = (curConfig) => {
  return {
    type: UPDATE_CURRENT_CONFIG,
    curConfig
  }
}

const initFilter = (filters, curConfig) => {
  return {
    type: INITIALIZE_FILTER,
    filters,
    curConfig
  }
}

const initConfigFilter = (filters) => {
  return {
    type:INITIALIZE_CONFIG_FILTER,
    filters,
  }
}

const updateFilter = (index, value) => {
  return {
    type: TOGGLE_FILTER,
    index,
    value
  }
}

const refreshFilter = () => {
  return {
    type: REFRESH_FILTER
  }
}

const isAddPart = (value) => {
  return {
    type: IS_ADD_PART,
    value,
  }
}

export const getUiActions = (uiPath) => {
  const createToggleAction = (type) => {
    return createNamedAction(type + uiPath, updateFilter)
  }
  const createInitAction = (type) => {
    return createNamedAction(type + uiPath, initFilter)
  }
  const createRefreshAction = (type) => {
    return createNamedAction(type + uiPath, refreshFilter)
  }
  const createInitFilterAction = (filters, curConfig) => {
    const initPartType = createInitAction(PART_TYPE)
    const initDensity = createInitAction(DENSITY)
    const initOrgSize = createInitAction(ORG_SIZE)
    const initOrgWidth = createInitAction(ORG_WIDTH)
    const initChannel = createInitAction(CHANNEL)
    const initConfig = createInitAction(CONFIG)

    return () => {
      return (dispatch) => {
        dispatch(initPartType(filters.partType, curConfig.partType))
        dispatch(initDensity(filters.density, curConfig.density))
        dispatch(initOrgSize(filters.organizationSize, curConfig.organizationSize))
        dispatch(initOrgWidth(filters.organizationWidth, curConfig.organizationWidth))
        dispatch(initChannel(filters.channel, curConfig.channel))
        dispatch(initConfig(filters.config, curConfig.config))
      }
    }
  }
  const createRefreshFilterAction = () => {
    const refreshPartType = createRefreshAction(PART_TYPE)
    const refreshDensity = createRefreshAction(DENSITY)
    const refreshOrgSize = createRefreshAction(ORG_SIZE)
    const refreshOrgWidth = createRefreshAction(ORG_WIDTH)
    const refreshChannel = createRefreshAction(CHANNEL)
    const refreshConfig = createRefreshAction(CONFIG)

    return () => {
      return dispatch => {
        dispatch(refreshPartType())
        dispatch(refreshDensity())
        dispatch(refreshOrgSize())
        dispatch(refreshOrgWidth())
        dispatch(refreshChannel())
        dispatch(refreshConfig())
      }
    }
  }

  return {
    togglePartType: createToggleAction(PART_TYPE),
    toggleDensity: createToggleAction(DENSITY),
    toggleOrgSize: createToggleAction(ORG_SIZE),
    toggleOrgWidth: createToggleAction(ORG_WIDTH),
    toggleChannel: createToggleAction(CHANNEL),
    toggleConfig: createToggleAction(CONFIG),
    initFilters: createInitFilterAction,
    initConfigFilter: createNamedAction(CONFIG + uiPath, initConfigFilter),
    refreshFilters: createRefreshFilterAction(),
    isAddPart: createNamedAction(uiPath, isAddPart),
  }
}
